import { createContext, useContext, useState } from "react";
import { Snackbar, Alert } from "@mui/material";

type SnackbarContextValue = {
  showSnackbar: (opts: any) => void;  
};
const SnackbarContext = createContext<SnackbarContextValue | null>(null);


export const useSnackbar = (): SnackbarContextValue => {
  const ctx = useContext(SnackbarContext);
  if (ctx === null) {
    throw new Error("useSnackbar must be used within <SnackbarProvider>");
  }
  return ctx;
};


export const SnackbarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
    duration: 3000,
  });

  const showSnackbar = ({
    message='',
    severity = "info",
    duration = 3000,
  }) => {
    setSnackbar({
      open: true,
      message,
      severity,
      duration,
    });
  };

  const handleClose = () => {
    
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={snackbar.duration}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ mt: 7 }}
      >
        <Alert
          onClose={handleClose}
          severity={snackbar.severity as any}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};